module.exports = __webpack_public_path__ + "static/media/2DGACM15.8cf4416f.jpg";